﻿import React from 'react';

// components
import PossessionsData from './Components/PossessionsData';
import PossessionsAccordionContainer from './Components/PossessionsAccordionContainer';

const SignedInPossessionsListing = () => {

    return (
        <PossessionsData>
            <PossessionsAccordionContainer />           
        </PossessionsData>
    )
}

export default SignedInPossessionsListing
